// composables/useMessageDlg.ts
import { ref } from 'vue';

const visible = ref(false);
const msgtype = ref('info');
const msg = ref('');
const buttons = ref<string[]>([]);
const title = ref('');
const msgDlgShowStatus = ref<"open" | "closed">("closed");
const callBackFN = ref<() => void>();
const closable = ref<boolean>(true);
let localResolve: (value: number | PromiseLike<number>) => void;

type TiposMsgDlg = "informa" | "atencao";
export const useMessageDlg = () => {

	/**
	 * Como funciona:
	 * - O msgDlg cria uma Promise e armazena em localResolve
	 * - O diálogo é mostrado
	 * - Quando clica em um botão é chamado handleResponse que por sua vez
	 * resolve a promise enviando o valor 'localResolve(value)'
	 */


	/**
	 * Exibe uma caixa de diálogo de mensagem personalizada.
	 * 
	 * @param titulo - O título que será exibido no cabeçalho da caixa de diálogo
	 * @param tipo - O tipo da mensagem (define o ícone e estilo da caixa de diálogo)
	 * @param mensagem - O texto da mensagem que será exibido no corpo da caixa de diálogo
	 * @param botoes - Array com os textos dos botões que serão exibidos
	 * @param callBack - (opcional) Função de callback que será chamada no unmounted
	 * @returns Uma Promise que resolve com o índice do botão clicado (0-based)
	 * 
	 * @example
	 * ```typescript
	 * const resposta = await msgDlg("Confirmação", TiposMsgDlg.Questao, "Deseja salvar?", ["Sim", "Não"], 
	 * () => {console.log("Callback executado");});
	 * if (resposta === 0) {
	 *   // Usuário clicou em "Sim"
	 * }
	 * 
	 * // execução do callback independente do resultado
	 * ```
	 */
	const msgDlg = async (titulo: string, tipo: TiposMsgDlg, mensagem: string, botoes: string[], isClosable: boolean = true): Promise<number> => {
		msgDlgShowStatus.value = "open";
		title.value = titulo;
		msg.value = mensagem;
		msgtype.value = tipo;
		buttons.value = botoes;
		visible.value = true;
		closable.value = isClosable;

		await nextTick();

		return new Promise(resolve => { localResolve = resolve });
	}

	const handleResponse = (value: number) => {
		// TODO analisar o handle
		localResolve(value);
		visible.value = false;
		msgDlgShowStatus.value = "closed";

	}

	return {
		msgtype,
		msg,
		buttons,
		title,
		visible,
		msgDlgShowStatus,
		callBackFN,
		closable,
		msgDlg,
		handleResponse
	}
}

